import type { SpecSchedule } from '../types';

/** 有关联 SKU 时用规格文案拼接；否则回退历史规格名称 */
export function formatSpecRowTitle(spec: Pick<SpecSchedule, 'specName' | 'linkedSkus'>): string {
  const parts = (spec.linkedSkus ?? [])
    .map(s => s.specText?.trim())
    .filter((x): x is string => !!x);
  if (parts.length > 0) return Array.from(new Set(parts)).join('/');
  return spec.specName?.trim() || '—';
}
